/* global Stripe */

// Native Stripe equivalent of three-ds-form.js (which drives Spreedly's 3DS
// lifecycle). The backend confirmed a SetupIntent that came back
// `requires_action`; here we run the 3DS challenge client-side and then
// resubmit so the backend can pick up the now-succeeded SetupIntent.
export default ({ publishableKey = undefined, clientSecret = undefined }) => ({
  async init() {
    this.stripe = Stripe(publishableKey);

    await this.start();
  },

  async start() {
    const { setupIntent } = await this.stripe.retrieveSetupIntent(clientSecret);
    const status = setupIntent && setupIntent.status;

    // Only run the challenge when the SetupIntent is actually awaiting it. A
    // reload — or landing here with a SetupIntent a previous attempt already
    // failed — leaves it terminal (requires_payment_method), and calling
    // confirmCardSetup on that just re-renders the challenge and resubmits: an
    // infinite loop. Guarding on the status keeps us out of it.
    if (status === 'requires_action' || status === 'requires_confirmation') {
      const result = await this.stripe.confirmCardSetup(clientSecret);

      if (!result.error) {
        // The challenge cleared. Resume regardless of the returned status: the
        // backend re-reads the SetupIntent fresh and completes or fails the
        // purchase (some cards settle to `succeeded` a beat after the challenge,
        // so trusting this client-side result would wrongly fail them).
        this.$refs.form.submit();
        return;
      }
    } else if (status === 'succeeded') {
      // Already authenticated (e.g. a resubmit of an authenticated intent).
      this.$refs.form.submit();
      return;
    }

    // The challenge failed, or the SetupIntent is no longer actionable. Flag it
    // so the backend fails the session cleanly and returns us to the card form
    // with a retry message, instead of re-running the dead challenge.
    this.$refs.threeDsFailed.value = '1';
    this.$refs.form.submit();
  },
});
